import { call, fork, put, select } from 'redux-saga/effects';
import { signalingUserRenamed, userRenamed } from 'features/users/actions';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { bulkExchangeEncryptedNameSaga } from 'features/e2ee/sagas/bulkExchangeEncryptedNameSaga';
import { User } from 'features/users/types';
import { selectUsersWithoutLocal } from 'features/users/usersSlice';
import { E2EEManager } from 'features/e2ee/E2EEManager';
import { selectRoomId } from 'features/room/roomSlice';
import { E2eeReceiver } from 'features/e2ee/E2eeReceiver';
import { e2eeDecrypt } from 'features/e2ee/utils/e2eeDecrypt';

export function* onUserRenamedSaga(action: ReturnType<typeof signalingUserRenamed>) {
  const {
    data: { id, name },
    initiator,
  } = action.payload;

  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  if (e2eeEnabled) {
    const roomId: string = yield select(selectRoomId);
    const receiver: E2eeReceiver | undefined = yield call(
      E2EEManager.getReceiver,
      initiator.id,
      roomId
    );

    if (!receiver?.sharedSecret) {
      return;
    }

    const decryptedName: string = yield call(e2eeDecrypt, name, receiver.sharedSecret);

    yield put(
      userRenamed({
        id,
        name: decryptedName,
      })
    );

    const roomUsers: User[] = yield select(selectUsersWithoutLocal);
    yield fork(bulkExchangeEncryptedNameSaga, roomUsers, { rename: true });

    return;
  }

  yield put(
    userRenamed({
      id,
      name,
    })
  );
}
